<div class="d-flex justify-content-between align-items-center mb-3">
  <h2 mat-dialog-title class="m-0">Version Details</h2>
  <span class="badge-v">v{{ data.version.version }}</span>
</div>

<mat-dialog-content class="modal-content-scroll">
  <div class="container-fluid">
    <div class="row">
      <!-- Header Info -->
      <div class="col-md-6 detail-section">
        <span class="detail-label">Status</span>
        <div class="detail-value text-capitalize">{{ data.version.status }}</div>
      </div>
      
      <div class="col-md-6 detail-section">
        <span class="detail-label">Source</span>
        <div class="detail-value text-capitalize">{{ data.version.generation_source || 'AI' }}</div>
      </div>

      <div class="col-12 detail-section" *ngIf="data.version.notes">
        <span class="detail-label">Notes</span>
        <div class="detail-value">{{ data.version.notes }}</div>
      </div>

      <div class="col-12">
        <hr>
        <h5 class="mb-3 fw-bold">Content JSON</h5>
      </div>

      <!-- JSON Content (Main Fields) -->
      <div class="col-12" *ngIf="data.version.content_json">
        <div class="json-field" *ngIf="data.version.content_json.headline">
          <span class="detail-label">Headline</span>
          <div class="detail-value">{{ data.version.content_json.headline }}</div>
        </div>

        <div class="json-field" *ngIf="data.version.content_json.intro">
          <span class="detail-label">Intro</span>
          <div class="detail-value">{{ data.version.content_json.intro }}</div>
        </div>

        <div class="json-field" *ngIf="data.version.content_json.meta_title">
          <span class="detail-label">Meta Title</span>
          <div class="detail-value">{{ data.version.content_json.meta_title }}</div>
        </div>

        <div class="json-field" *ngIf="data.version.content_json.meta_description">
          <span class="detail-label">Meta Description</span>
          <div class="detail-value">{{ data.version.content_json.meta_description }}</div>
        </div>

        <!-- Sections Array -->
        <div class="json-field" *ngIf="data.version.content_json.sectionsArray && isArray(data.version.content_json.sectionsArray)">
          <span class="detail-label">Sections</span>
          <div class="detail-value">
            <div *ngFor="let section of data.version.content_json.sectionsArray; let i = index" class="mb-3">
              <strong class="d-block mb-1">{{ i + 1 }}. {{ section.title || section.heading }}</strong>
              <p class="mb-0 small">{{ section.content || section.text || section.body }}</p>
            </div>
          </div>
        </div>

        <!-- FAQ Array -->
        <div class="json-field" *ngIf="data.version.content_json.faqArray && isArray(data.version.content_json.faqArray)">
          <span class="detail-label">FAQ</span>
          <div class="detail-value">
            <div *ngFor="let faq of data.version.content_json.faqArray" class="mb-2">
              <strong class="d-block small">Q: {{ faq.question }}</strong>
              <p class="mb-0 x-small text-muted">A: {{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="!data.version.content_json">
        <p class="text-muted italic">No structured content available.</p>
      </div>

      <!-- Raw Text -->
      <div class="col-12 detail-section mt-4" *ngIf="data.version.content_text">
        <span class="detail-label">Full Text</span>
        <div class="detail-value" style="font-size: 0.85rem;">{{ data.version.content_text }}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 bg-light border-top">
  <button class="btn btn-dark btn-sm px-4" (click)="close()">Close</button>
</mat-dialog-actions>
